<template>
  <div>
    <LoadingWidget v-if="loading" :color="`white`" />
    <v-sheet
      class="d-flex align-center py-10 py-md-0"
      color="primary"
      min-height="347px"
      height="100%"
    >
      <v-container v-if="!loading">
        <v-row align="start" justify="center" class="categories-container">
          <template v-for="({ text, img, to }, i) in items">
            <v-col
              cols="6"
              sm="3"
              lg="2"
              class="text-center item"
              v-if="img && text"
              :key="i"
            >
              <router-link
                class="d-flex align-center flex-column text-decoration-none"
                :to="to"
                v-ripple
              >
                <div
                  class="
                    item-img
                    primary
                    lighten-1
                    d-flex
                    align-center
                    justify-center
                  "
                >
                  <img :src="files + img" :alt="text" />
                </div>
                <span
                  class="
                    white--text
                    font-weight-medium
                    mt-4
                    text-caption text-sm-body-1
                  "
                  >{{ text }}</span
                >
              </router-link>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import { formatToURL } from "../../utils/formatToURL";
const _config = {
  mod: "categories",
};

export default {
  data: () => ({
    loading: true,
    itemsPerPage: 6,
    items: [],
    page: "/produtos",
  }),

  mounted() {
    this.loading = true;
    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: this.itemsPerPage,
        },
      })
      .then((data) => {
        this.items = data.map(({ title, icon }) => ({
          text: title,
          img: icon,
          to: `${this.page}/${formatToURL(title)}`,
        }));
      })
      .then(() => (this.loading = false));
  },

  methods: {
    formatToURL,
  },

  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.categories-container {
  flex-wrap: wrap;
}
.item {
  flex-wrap: wrap;
  &-img {
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
  img {
    height: 60px;
    width: 70px;
    object-fit: contain;
  }
}
</style>
